export const blogAuthors = {
  nxhost: {
    id: "nxhost",
    name: "Equipe NXHOST",
    role: "Time de conteúdo NXHOST",
    bio: "Conteúdos produzidos pela equipe NXHOST sobre tecnologia, hospedagem, desenvolvimento web, SEO, marketing digital e soluções para empresas.",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20friendly%20customer%20support%20team%20working%20together%20in%20a%20bright%20modern%20technology%20office%2C%20blue%20tones%2C%20clean%20corporate%20atmosphere%2C%20editorial%20photography&width=400&height=400&seq=nx-author-team&orientation=squarish",
  },
};

export const blogCategories = [
  {
    slug: "hospedagem-de-sites",
    name: "Hospedagem de Sites",
    shortName: "Hospedagem",
    description: "Hospedagem compartilhada, recursos, desempenho, segurança, SSL, backups e migração.",
    longDescription:
      "Guia completo de hospedagem de sites: como escolher o plano ideal, desempenho, SSL, backups, migração e segurança para manter seu site rápido, estável e sempre no ar.",
    icon: "ri-server-line",
    accent: "primary",
    ogImage:
      "https://readdy.ai/api/search-image?query=Modern%20dark%20navy%20server%20room%20illustration%20with%20glowing%20cyan%20network%20cables%20and%20abstract%20hosting%20icons%2C%20clean%20minimal%20tech%20background%2C%20soft%20gradient%20lighting%2C%20editorial%20digital%20art%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=630&seq=og-cat-hospedagem&orientation=landscape",
    topics: ["Hospedagem compartilhada", "SSL e segurança", "Backups", "Migração", "Desempenho"],
    faqs: [
      {
        question: "O que é hospedagem de sites e como ela funciona?",
        answer:
          "É o serviço que guarda os arquivos do seu site em um servidor conectado à internet 24 horas por dia, garantindo que ele fique disponível para os visitantes a qualquer momento.",
      },
      {
        question: "Qual hospedagem é ideal para o meu projeto?",
        answer:
          "Depende do tráfego e dos recursos: sites institucionais e blogs costumam ir bem em hospedagem compartilhada, enquanto projetos com muito acesso podem precisar de VPS ou servidor dedicado.",
      },
      {
        question: "Preciso de conhecimentos técnicos para contratar hospedagem?",
        answer:
          "Não. Os planos da NXHOST incluem painel de controle, instalação de SSL e suporte especializado para ajudar na configuração e na migração do seu site.",
      },
    ],
  },
  {
    slug: "criacao-de-sites",
    name: "Criação de Sites",
    shortName: "Sites",
    description: "Desenvolvimento web, WordPress, HTML, CSS, responsividade, UX e estrutura de sites.",
    longDescription:
      "Tutoriais de criação de sites e desenvolvimento web: WordPress, HTML, CSS, JavaScript, responsividade, UX e velocidade para montar um site profissional que converte visitantes em clientes.",
    icon: "ri-layout-masonry-line",
    accent: "accent",
    ogImage:
      "https://readdy.ai/api/search-image?query=Modern%20web%20design%20workspace%20concept%20with%20abstract%20browser%20windows%20and%20layout%20wireframes%20floating%20on%20a%20dark%20navy%20background%2C%20cyan%20and%20teal%20accents%2C%20clean%20minimal%20digital%20illustration%2C%20soft%20glow%2C%20editorial%20style%2C%20high%20detail&width=1200&height=630&seq=og-cat-sites&orientation=landscape",
    topics: ["WordPress", "HTML e CSS", "Responsividade", "UX", "Velocidade"],
    faqs: [
      {
        question: "Quanto tempo leva para criar um site profissional?",
        answer:
          "Varia conforme a complexidade. Um site institucional costuma ficar pronto em poucos dias, enquanto projetos com muitas páginas e integrações exigem mais tempo.",
      },
      {
        question: "Posso criar meu site sem saber programar?",
        answer:
          "Sim. Com plataformas como WordPress e construtores visuais é possível montar um site completo, e o blog traz tutoriais passo a passo para isso.",
      },
      {
        question: "Um site próprio ajuda a atrair clientes?",
        answer:
          "Sim. Um site profissional aumenta a credibilidade, aparece nas buscas do Google e funciona como uma vitrine que apresenta sua empresa 24 horas por dia.",
      },
    ],
  },
  {
    slug: "dominios",
    name: "Domínios e DNS",
    shortName: "Domínios",
    description: "Registro, transferência, DNS, nameservers e apontamento de domínio.",
    longDescription:
      "Tudo sobre domínios e DNS: registro, transferência, nameservers, apontamento de domínio e registros A, AAAA, CNAME, MX e TXT explicados de forma simples e passo a passo.",
    icon: "ri-global-line",
    accent: "secondary",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20globe%20and%20network%20connection%20concept%20on%20a%20dark%20navy%20background%20with%20glowing%20cyan%20nodes%20and%20lines%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20gradient%20lighting%2C%20clean%20composition%2C%20high%20detail&width=1200&height=630&seq=og-cat-dominios&orientation=landscape",
    topics: ["O que é domínio", "DNS", "Nameservers", "Registro A e CNAME", "MX e TXT"],
    faqs: [
      {
        question: "O que é um domínio e por que preciso registrar um?",
        answer:
          "O domínio é o endereço do seu site na internet (como suaempresa.com.br). Sem ele, os visitantes não conseguem encontrar o seu projeto de forma profissional.",
      },
      {
        question: "Quanto tempo leva para um domínio ficar ativo?",
        answer:
          "Depois do registro, a propagação do DNS costuma levar de algumas horas a até 24 horas para funcionar em todo o mundo.",
      },
      {
        question: "Posso usar o mesmo domínio em vários serviços?",
        answer:
          "Sim. Com a configuração correta de DNS você aponta o mesmo domínio para site, e-mails e outros serviços, como lojas virtuais e sistemas.",
      },
    ],
  },
  {
    slug: "directadmin",
    name: "DirectAdmin",
    shortName: "DirectAdmin",
    description: "Painel DirectAdmin: e-mails, bancos, SSL, subdomínios, backup e arquivos.",
    longDescription:
      "Tutoriais de DirectAdmin do zero: acesso ao painel, e-mails, bancos de dados, SSL, subdomínios, backup e gerenciamento de arquivos na sua hospedagem.",
    icon: "ri-window-2-line",
    accent: "primary",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20hosting%20control%20panel%20dashboard%20concept%20with%20clean%20interface%20cards%20and%20toggles%20on%20a%20dark%20navy%20background%2C%20cyan%20and%20teal%20highlights%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20glow%2C%20editorial%20style&width=1200&height=630&seq=og-cat-directadmin&orientation=landscape",
    topics: ["Primeiros passos", "E-mails", "Bancos de dados", "SSL", "Subdomínios", "Backup"],
    faqs: [
      {
        question: "O que é o DirectAdmin?",
        answer:
          "É um painel de controle de hospedagem, leve e rápido, usado para gerenciar sites, e-mails, bancos de dados, SSL e arquivos.",
      },
      {
        question: "Preciso de experiência para usar o DirectAdmin?",
        answer:
          "Não. A interface é simples e intuitiva, e os tutoriais do blog mostram desde o primeiro acesso até as configurações avançadas.",
      },
      {
        question: "Consigo criar e-mails profissionais no DirectAdmin?",
        answer:
          "Sim. Você pode criar contas de e-mail com o seu domínio (contato@suaempresa.com.br), configurar respondedores e gerenciar tudo pelo painel.",
      },
    ],
  },
  {
    slug: "cpanel",
    name: "cPanel",
    shortName: "cPanel",
    description: "Tutoriais de cPanel: e-mails, MySQL, SSL, arquivos, FTP e Softaculous.",
    longDescription:
      "Tutoriais de cPanel passo a passo: e-mails, MySQL, SSL, gerenciador de arquivos, FTP e Softaculous para administrar sua hospedagem com facilidade e segurança.",
    icon: "ri-dashboard-3-line",
    accent: "accent",
    ogImage:
      "https://readdy.ai/api/search-image?query=Modern%20web%20control%20dashboard%20abstract%20illustration%20with%20organized%20panels%20and%20icons%20on%20a%20dark%20navy%20background%2C%20cyan%20accents%2C%20minimal%20clean%20digital%20art%2C%20soft%20gradient%20lighting%2C%20high%20detail%2C%20harmonious&width=1200&height=630&seq=og-cat-cpanel&orientation=landscape",
    topics: ["Primeiros passos", "E-mails", "MySQL", "SSL", "Gerenciador de arquivos", "Softaculous"],
    faqs: [
      {
        question: "O que é o cPanel e para que serve?",
        answer:
          "É um dos painéis de hospedagem mais usados do mundo, com recursos para gerenciar e-mails, arquivos, bancos de dados, SSL e instalações automáticas de aplicativos.",
      },
      {
        question: "Posso instalar WordPress pelo cPanel?",
        answer:
          "Sim. Com a ferramenta Softaculous, disponível no cPanel, você instala o WordPress em poucos cliques, sem precisar de conhecimentos técnicos.",
      },
      {
        question: "O cPanel é difícil de usar para iniciantes?",
        answer:
          "Não. O painel é organizado por categorias de tarefas e o blog reúne tutoriais ilustrados de cada função, do básico ao avançado.",
      },
    ],
  },
  {
    slug: "vps-servidores",
    name: "VPS e Servidores",
    shortName: "VPS",
    description: "VPS, servidores Linux, desempenho, segurança e administração de servidores.",
    longDescription:
      "Conteúdos de VPS e servidores Linux: o que é um VPS, diferenças para hospedagem compartilhada, administração, segurança, desempenho e monitoramento de servidores.",
    icon: "ri-hard-drive-3-line",
    accent: "secondary",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20stack%20of%20modern%20rack%20servers%20with%20glowing%20cyan%20status%20lights%20on%20a%20dark%20navy%20background%2C%20minimal%20tech%20illustration%2C%20soft%20gradient%20lighting%2C%20clean%20composition%2C%20editorial%20digital%20art%2C%20high%20detail&width=1200&height=630&seq=og-cat-vps&orientation=landscape",
    topics: ["O que é VPS", "VPS x hospedagem", "Linux", "Segurança", "Monitoramento"],
    faqs: [
      {
        question: "O que é um VPS e quando devo usar?",
        answer:
          "VPS (Servidor Privado Virtual) é um servidor com recursos dedicados a você. É indicado para sites com alto tráfego, lojas virtuais e aplicações que precisam de mais desempenho e controle.",
      },
      {
        question: "Qual a diferença entre VPS e hospedagem compartilhada?",
        answer:
          "Na hospedagem compartilhada você divide o servidor com outros sites; no VPS os recursos são exclusivos, o que garante mais estabilidade, velocidade e liberdade de configuração.",
      },
      {
        question: "Preciso saber administrar um servidor Linux?",
        answer:
          "Não necessariamente. A NXHOST oferece opções de VPS gerenciado e materiais no blog para você aprender a administrar e monitorar seu servidor com segurança.",
      },
    ],
  },
  {
    slug: "banco-de-dados",
    name: "Banco de Dados",
    shortName: "Banco de Dados",
    description: "MySQL, MariaDB, PostgreSQL, phpMyAdmin, criação, backup e otimização.",
    longDescription:
      "Bancos de dados em hospedagem: criação, usuários, permissões, backup, restauração, importação e exportação em MySQL, MariaDB e PostgreSQL, com tutoriais práticos.",
    icon: "ri-database-2-line",
    accent: "primary",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20database%20cylinders%20and%20data%20flow%20concept%20on%20a%20dark%20navy%20background%20with%20glowing%20cyan%20connection%20lines%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20gradient%20lighting%2C%20clean%20composition%2C%20high%20detail&width=1200&height=630&seq=og-cat-database&orientation=landscape",
    topics: ["MySQL", "MariaDB", "PostgreSQL", "phpMyAdmin", "Backup"],
    faqs: [
      {
        question: "O que é um banco de dados em hospedagem?",
        answer:
          "É o local onde ficam armazenadas as informações do seu site, como usuários, produtos e pedidos. Sem ele, sistemas como WordPress e lojas virtuais não funcionam.",
      },
      {
        question: "Qual banco de dados é melhor: MySQL ou PostgreSQL?",
        answer:
          "Depende do projeto. O MySQL (e o MariaDB) é o mais usado por WordPress e pela maioria dos sites; o PostgreSQL é indicado para aplicações que exigem recursos mais avançados.",
      },
      {
        question: "Como faço backup do meu banco de dados?",
        answer:
          "Você pode exportar o banco pelo painel (phpMyAdmin ou a ferramenta do DirectAdmin/cPanel) e também contar com backups automáticos incluídos na hospedagem NXHOST.",
      },
    ],
  },
  {
    slug: "mysql",
    name: "MySQL",
    shortName: "MySQL",
    description: "MySQL na prática: criar banco, usuário, conectar PHP, backup e importação.",
    longDescription:
      "MySQL na prática: como criar banco de dados e usuário, conectar com PHP, fazer backup, restaurar dados e resolver os erros mais comuns passo a passo.",
    icon: "ri-archive-stack-line",
    accent: "accent",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20database%20table%20and%20query%20concept%20with%20floating%20data%20rows%20on%20a%20dark%20navy%20background%2C%20cyan%20and%20teal%20accents%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20glow%2C%20editorial%20style%2C%20high%20detail&width=1200&height=630&seq=og-cat-mysql&orientation=landscape",
    topics: ["Criar banco", "Criar usuário", "PHP e MySQL", "Backup", "Importar e exportar"],
    faqs: [
      {
        question: "Como criar um banco de dados MySQL na hospedagem?",
        answer:
          "Pelo painel de controle (DirectAdmin ou cPanel) você cria o banco, define um usuário e a senha e associa as permissões em poucos passos.",
      },
      {
        question: "Como conectar o MySQL ao meu site em PHP?",
        answer:
          "Basta informar o host, o nome do banco, o usuário e a senha no arquivo de configuração do seu site; o blog traz exemplos práticos de conexão.",
      },
      {
        question: "O que fazer quando o MySQL apresenta erro de conexão?",
        answer:
          "Na maioria dos casos é senha, usuário ou permissão incorretos, ou o banco excedeu o limite. O blog reúne os erros mais comuns do MySQL e como resolvê-los.",
      },
    ],
  },
  {
    slug: "ssh-linux",
    name: "SSH e Linux",
    shortName: "SSH e Linux",
    description: "Terminal, comandos Linux, permissões, processos, serviços e segurança SSH.",
    longDescription:
      "SSH e Linux para servidores: terminal, comandos essenciais, permissões de arquivos, processos, serviços, logs e boas práticas de segurança para administrar seu servidor.",
    icon: "ri-terminal-box-line",
    accent: "secondary",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20terminal%20command%20line%20window%20with%20glowing%20cyan%20code%20text%20on%20a%20dark%20navy%20background%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20gradient%20lighting%2C%20clean%20composition%2C%20editorial%20style%2C%20high%20detail&width=1200&height=630&seq=og-cat-ssh&orientation=landscape",
    topics: ["O que é SSH", "Comandos básicos", "Permissões", "Processos", "Segurança"],
    faqs: [
      {
        question: "O que é SSH e para que serve?",
        answer:
          "SSH é um protocolo seguro para acessar o terminal do servidor à distância. Com ele você executa comandos, ajusta configurações e administra arquivos com segurança.",
      },
      {
        question: "Quais comandos Linux preciso conhecer?",
        answer:
          "Comandos básicos como ls, cd, cp, mv, rm, chmod e top já permitem administrar boa parte do servidor; o blog explica cada um na prática.",
      },
      {
        question: "O SSH é seguro?",
        answer:
          "Sim, quando bem configurado. Usar chaves de acesso em vez de senha, trocar a porta padrão e limitar o acesso por IP são boas práticas que você aprende no blog.",
      },
    ],
  },
  {
    slug: "seo",
    name: "SEO",
    shortName: "SEO",
    description: "SEO on-page, técnico, palavras-chave, Search Console, sitemap e Core Web Vitals.",
    longDescription:
      "SEO completo: fundamentos, SEO on-page e técnico, pesquisa de palavras-chave, Search Console, sitemap, Core Web Vitals e SEO local para aparecer no Google.",
    icon: "ri-search-eye-line",
    accent: "primary",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20search%20engine%20optimization%20concept%20with%20rising%20growth%20chart%20and%20magnifier%20on%20a%20dark%20navy%20background%2C%20cyan%20and%20teal%20accents%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20glow%2C%20high%20detail%2C%20editorial&width=1200&height=630&seq=og-cat-seo&orientation=landscape",
    topics: ["O que é SEO", "SEO On-Page", "SEO Técnico", "Palavras-chave", "Search Console", "SEO local"],
    faqs: [
      {
        question: "O que é SEO e por que ele importa?",
        answer:
          "SEO é o conjunto de técnicas para o seu site aparecer bem posicionado no Google. Um bom SEO traz visitantes qualificados sem depender de anúncios pagos.",
      },
      {
        question: "Quanto tempo o SEO leva para dar resultado?",
        answer:
          "Costuma variar de algumas semanas a alguns meses, dependendo da concorrência. É um trabalho contínuo, mas o resultado é duradouro e acumulativo.",
      },
      {
        question: "Preciso de ferramentas pagas para fazer SEO?",
        answer:
          "Não. O Search Console, o Analytics e o próprio sitemap do site já oferecem dados essenciais, e o blog ensina a usar cada um deles.",
      },
    ],
  },
  {
    slug: "marketing-digital",
    name: "Marketing Digital",
    shortName: "Marketing",
    description: "Funil de vendas, leads, conversão, landing pages, conteúdo e automação.",
    longDescription:
      "Marketing digital para empresas: funil de vendas, geração de leads, conversão, landing pages, conteúdo, e-mail marketing e branding para crescer na internet.",
    icon: "ri-megaphone-line",
    accent: "accent",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20digital%20marketing%20funnel%20with%20floating%20icons%20and%20connection%20lines%20on%20a%20dark%20navy%20background%2C%20cyan%20and%20teal%20accents%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20gradient%20lighting%2C%20high%20detail&width=1200&height=630&seq=og-cat-marketing&orientation=landscape",
    topics: ["Funil de vendas", "Leads", "Conversão", "Landing pages", "E-mail marketing", "Branding"],
    faqs: [
      {
        question: "O que é marketing digital?",
        answer:
          "É o conjunto de estratégias para divulgar a sua marca e vender pela internet, usando canais como redes sociais, e-mail, conteúdo e anúncios.",
      },
      {
        question: "Como gerar leads para o meu negócio?",
        answer:
          "Oferecendo conteúdo relevante e uma boa página de captura, você atrai visitantes e os transforma em contatos interessados nos seus produtos.",
      },
      {
        question: "Marketing digital funciona para pequenas empresas?",
        answer:
          "Sim, e costuma ser ainda mais vantajoso para elas, porque permite começar com investimentos menores e medir resultados com precisão.",
      },
    ],
  },
  {
    slug: "google-ads",
    name: "Google Ads",
    shortName: "Google Ads",
    description: "Campanhas, palavras-chave, anúncios, CPC, CTR, conversões e remarketing.",
    longDescription:
      "Google Ads na prática: como criar campanhas, escolher palavras-chave, escrever anúncios e acompanhar CPC, CTR, conversões e remarketing para vender mais.",
    icon: "ri-google-fill",
    accent: "secondary",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20online%20advertising%20campaign%20concept%20with%20target%20and%20click%20icons%20on%20a%20dark%20navy%20background%2C%20glowing%20cyan%20accents%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20glow%2C%20editorial%20style%2C%20high%20detail&width=1200&height=630&seq=og-cat-google-ads&orientation=landscape",
    topics: ["O que é Google Ads", "Criar campanha", "Palavras-chave", "Anúncios", "Conversões"],
    faqs: [
      {
        question: "O que é Google Ads e como funciona?",
        answer:
          "É a plataforma de anúncios do Google. Você cria campanhas, escolhe palavras-chave e o seu anúncio aparece para quem está buscando pelo que você oferece.",
      },
      {
        question: "Quanto custa anunciar no Google Ads?",
        answer:
          "Você define o orçamento diário. O valor cobrado depende do leilão de palavras-chave e pode ser ajustado a qualquer momento para caber no seu bolso.",
      },
      {
        question: "Como medir os resultados das campanhas?",
        answer:
          "Acompanhando métricas como impressões, cliques, CTR, CPC e conversões dentro da própria plataforma, além de ferramentas de análise como o Google Analytics.",
      },
    ],
  },
  {
    slug: "logo-identidade-visual",
    name: "Logo e Identidade Visual",
    shortName: "Logotipo",
    description: "Como criar um logo, identidade visual, cores, tipografia e branding.",
    longDescription:
      "Marca e identidade visual: como criar um logo profissional, escolher cores e tipografia e construir uma identidade visual consistente para sua empresa.",
    icon: "ri-palette-line",
    accent: "primary",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20brand%20identity%20design%20concept%20with%20geometric%20logo%20shapes%20and%20color%20swatches%20on%20a%20dark%20navy%20background%2C%20cyan%20and%20teal%20accents%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20glow%2C%20high%20detail&width=1200&height=630&seq=og-cat-branding&orientation=landscape",
    topics: ["Criar um logo", "Identidade visual", "Cores", "Tipografia", "Branding"],
    faqs: [
      {
        question: "Por que uma empresa precisa de um bom logo?",
        answer:
          "O logo é a cara da sua marca. Um logo bem feito transmite profissionalismo, facilita o reconhecimento e ajuda a conquistar a confiança dos clientes.",
      },
      {
        question: "O que compõe uma identidade visual?",
        answer:
          "Além do logo, envolvem-se cores, tipografia, formas e o padrão de aplicação da marca em materiais, redes sociais e no site.",
      },
      {
        question: "Posso criar meu próprio logotipo?",
        answer:
          "Sim. Com os princípios certos de design, presentes no blog, é possível criar um logo simples e profissional, ou contratar o serviço de criação da NXHOST.",
      },
    ],
  },
  {
    slug: "loja-virtual",
    name: "E-commerce e Loja Virtual",
    shortName: "Loja Virtual",
    description: "Como criar uma loja virtual, produtos, checkout, pagamentos, frete e SEO.",
    longDescription:
      "E-commerce e loja virtual: como criar sua loja online, cadastrar produtos, configurar checkout, meios de pagamento, frete, SEO e conversão para vender mais.",
    icon: "ri-shopping-bag-3-line",
    accent: "accent",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20online%20store%20concept%20with%20floating%20shopping%20bag%20and%20product%20cards%20on%20a%20dark%20navy%20background%2C%20cyan%20and%20teal%20accents%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20gradient%20lighting%2C%20high%20detail&width=1200&height=630&seq=og-cat-ecommerce&orientation=landscape",
    topics: ["Como criar uma loja", "Produtos", "Checkout", "Pagamentos", "Frete", "SEO para e-commerce"],
    faqs: [
      {
        question: "Quanto custa criar uma loja virtual?",
        answer:
          "Depende dos recursos. Você pode começar com uma plataforma acessível e evoluir conforme as vendas crescem, pagando apenas o que o seu negócio precisa.",
      },
      {
        question: "Quais meios de pagamento posso oferecer?",
        answer:
          "Cartão de crédito, Pix, boleto e carteiras digitais são os mais usados no Brasil; o blog explica como configurar cada um de forma segura.",
      },
      {
        question: "Uma loja virtual precisa de hospedagem específica?",
        answer:
          "Sim. Lojas exigem uma hospedagem mais robusta, com bom desempenho e segurança, para suportar acessos e transações sem cair.",
      },
    ],
  },
  {
    slug: "guias-tutoriais",
    name: "Guias e Tutoriais",
    shortName: "Guias",
    description: "Tutoriais passo a passo para resolver problemas e aprender tecnologia na prática.",
    longDescription:
      "Guias e tutoriais passo a passo para configurar serviços, resolver problemas e aprender tecnologia na prática, do nível iniciante ao avançado.",
    icon: "ri-guide-line",
    accent: "secondary",
    ogImage:
      "https://readdy.ai/api/search-image?query=Abstract%20step%20by%20step%20guide%20and%20tutorial%20concept%20with%20numbered%20blocks%20and%20a%20path%20on%20a%20dark%20navy%20background%2C%20cyan%20and%20teal%20accents%2C%20minimal%20modern%20digital%20illustration%2C%20soft%20glow%2C%20editorial%20style&width=1200&height=630&seq=og-cat-guias&orientation=landscape",
    topics: ["Iniciante", "Intermediário", "Avançado"],
    collection: true,
    faqs: [
      {
        question: "Os guias são para quem está começando?",
        answer:
          "Sim. Os tutoriais são organizados por nível iniciante, intermediário e avançado, para você aprender no seu ritmo.",
      },
      {
        question: "Os tutoriais são gratuitos?",
        answer:
          "Sim, todos os guias e tutoriais do blog NXHOST são gratuitos e abertos a qualquer visitante.",
      },
      {
        question: "Com que frequência novos tutoriais são publicados?",
        answer:
          "Novos conteúdos são publicados regularmente, sempre que possível acompanhando as dúvidas mais comuns dos nossos clientes.",
      },
    ],
  },
];

export const blogTags = [
  "Hospedagem",
  "WordPress",
  "cPanel",
  "DirectAdmin",
  "MySQL",
  "Linux",
  "SSH",
  "VPS",
  "SEO",
  "Google",
  "Google Ads",
  "Domínio",
  "DNS",
  "SSL",
  "PHP",
  "E-commerce",
  "Loja virtual",
  "Site profissional",
  "Marketing",
  "Branding",
];

export const blogFaqs = [
  {
    question: "O que é o Blog NXHOST?",
    answer:
      "É uma central de conteúdos sobre tecnologia, hospedagem, sites, servidores, SEO e marketing digital, produzida para ajudar empresas e profissionais a resolver dúvidas reais e crescer na internet.",
  },
  {
    question: "Posso encontrar tutoriais técnicos?",
    answer:
      "Sim. O blog reúne tutoriais práticos sobre hospedagem, DirectAdmin, cPanel, Linux, SSH, MySQL, DNS e outros assuntos, organizados por nível iniciante, intermediário e avançado.",
  },
  {
    question: "Os conteúdos são gratuitos?",
    answer:
      "Sim, todos os conteúdos publicados no blog são disponibilizados gratuitamente e podem ser acessados por qualquer visitante.",
  },
  {
    question: "Posso solicitar ajuda com um problema específico?",
    answer:
      "Sim. Você pode entrar em contato com a NXHOST para conhecer as soluções disponíveis e contar com suporte para o seu projeto.",
  },
];